export const reportCustom = {
  used: ["B9ILN6FC8L7O", "BLU95KI5B1HY"],
};

export const reportCustomModel = [
  {
    brand: "B9ILN6FC8L7O",
    brandName: "ovaltine freefire",
    api: `${"https://dev-bcrm-ovt-freefire-api.azurewebsites.net"}${"/Api/v1/Customer/CustomerList"}`,
  },
  {
    brand: "BMGPJ9JDHIFA",
    brandName: "ovaltine smart",
    api: `${"https://dev-bcrm-ovt-smart-api.azurewebsites.net"}${"/Api/v1/Backoffice/Customer/GetCustomers"}`,
  },
  {
    brand: "BLU95KI5B1HY",
    brandName: "thanachart tni",
    api: `${"https://dev-bcrm-thanachart-api.azurewebsites.net"}${"/api/v1/Backoffice/customer/GetCustomers"}`,
  },
];
